import React from "react";

// Decorative animated international route lines. Purely visual (aria-hidden).
// Route dashes animate slowly; disabled under prefers-reduced-motion via CSS.
export const RouteLines = ({ className = "", stroke = "#0B6E69", opacity = 0.5 }) => (
  <svg
    className={className}
    viewBox="0 0 800 400"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    <g opacity={opacity}>
      <path className="route-dash" d="M60 320 C 220 120, 360 120, 520 200 S 720 260, 760 120"
        stroke={stroke} strokeWidth="1.5" />
      <path className="route-dash" d="M40 120 C 200 260, 380 200, 560 280 S 720 200, 780 300"
        stroke={stroke} strokeWidth="1.5" style={{ animationDelay: "-6s" }} />
      <path className="route-dash" d="M120 60 C 260 180, 420 60, 600 140"
        stroke={stroke} strokeWidth="1.2" style={{ animationDelay: "-12s" }} />
    </g>
    {/* connection nodes */}
    {[[60, 320], [520, 200], [760, 120], [560, 280], [600, 140], [120, 60]].map(([cx, cy], i) => (
      <circle key={i} cx={cx} cy={cy} r={i % 3 === 0 ? 4 : 2.5}
        fill={i % 3 === 0 ? "#D28A32" : stroke} opacity="0.9" />
    ))}
  </svg>
);

export default RouteLines;
